export class Mesh {
    indices = null;
    attributes = {};
    _gl;
    _count;
    constructor(gl) {
        this._gl = gl;
        this._count = 0;
        this._vertCount = 0;
    }
    _vertCount;
    get vertCount() {
        return this._vertCount;
    }
    dispose() {
        Object.keys(this.attributes).forEach(key => {
            this.attributes[key].dispose();
            delete this.attributes[key];
        });
    }
    setAttribute(key, buffer) {
        if (this.attributes[key]) {
            this.attributes[key].dispose();
            delete this.attributes[key];
        }
        if (!buffer) {
            return;
        }
        this.attributes[key] = buffer;
    }
    update() {
        const gl = this._gl;
        ['POSITION', 'TEXCOORD'].forEach(key => {
            if (this.attributes[key]) {
                this.attributes[key].update(gl.ARRAY_BUFFER, true);
            }
        });
        if (this.indices) {
            this.indices.update(gl.ELEMENT_ARRAY_BUFFER, true);
        }
        this._count = this.indices?.array.length || 0;
        this._vertCount = this.attributes['POSITION'] ? this.attributes['POSITION'].array.length / 3 : 0;
    }
    draw(shader) {
        const gl = this._gl;
        ['POSITION', 'TEXCOORD', 'TEXCOORD2', 'NORMAL', 'COLOR'].forEach(key => {
            const attribute = shader.getAttribute(key);
            if (attribute > -1 && this.attributes[key]) {
                const buffer = this.attributes[key];
                gl.enableVertexAttribArray(attribute);
                gl.bindBuffer(gl.ARRAY_BUFFER, buffer.buffer);
                gl.vertexAttribPointer(attribute, buffer.size, gl.FLOAT, false, 0, 0);
            }
        });
        if (this.indices) {
            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.indices.buffer);
            gl.drawElements(gl.TRIANGLES, this._count, gl.UNSIGNED_SHORT, 0);
        }
    }
}
//# sourceMappingURL=Mesh.js.map